import { takeLatest, all, call, put } from "redux-saga/effects";
import {
  tcnResponseSearchSuccess,
  tcnResponseSearchFailure,
  tcnResponseSearchChanged,
  getTCNDispositionGroupFailure,
  getTCNDispositionGroupResponseChanged,
  getTCNDispositionGroupSuccess,
  tcnResponseExportAllFailure,
  tcnResponseExportAllSuccess,
  tcnResponseExportAllChanged,
} from "./tcnResponse.action";
import tcnResponseTypes from "./tcnResponse.types";
import {
  tcnResponseGetAPI,
  ComonExportPage,
  getTCNDispositionGroupAPI,
} from "./tcnResponse.Service";
import { encryptData } from "../../_common/enode-decode";

//*******************TCN SEARCH DETAILS START************************/
export function* searchStart({ payload }: any) {
  const key: any = "TCNResponseKey";
  try {
    const jsonData: any = {
      AgentID: payload.agentID,
      Disposition: payload.disposition,
      PhoneNumber: payload.phoneNumber,
      ModeOfDialling: payload.modeOfDialling,
      FromDate: payload.fromDate,
      ToDate: payload.toDate,
      CompanyID: payload.companyID,
      Limit: payload.limit,
      InstanceName: payload.InstanceName,
    };
    const formData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(tcnResponseGetAPI, formData);

    if (responseData.statusCode === "100") {
      yield put(tcnResponseSearchFailure(responseData.data));
    } else {
      yield put(tcnResponseSearchSuccess(responseData.data));
    }
  } catch (error) {
    yield put(tcnResponseSearchFailure(error));
  }
}
export function* searchChange() {
  yield put(tcnResponseSearchChanged());
}

export function* searchStartSaga() {
  yield takeLatest(tcnResponseTypes.TCN_RESPONSE_SEARCH_START, searchStart);
}
export function* searchResetSaga() {
  yield takeLatest(tcnResponseTypes.TCN_RESPONSE_SEARCH_RESET, searchChange);
}
//*******************TCN SEARCH DETAILS END************************/

export function* fetchTCNDispositionGroup({ payload }: any) {
  const key: any = "GetAllGroupDispositionKey";
  try {
    const jsonData: any = {
      InstanceName: payload.InstanceName,
    };
    const encodedData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(getTCNDispositionGroupAPI, encodedData);
    if (responseData.data.statusCode === "100") {
      yield put(getTCNDispositionGroupFailure(responseData.data));
    } else {
      yield put(getTCNDispositionGroupSuccess(responseData.data));
    }
  } catch (error) {
    yield put(getTCNDispositionGroupFailure(error));
  }
}

export function* resetTCNDispositionGroupResponse() {
  yield put(getTCNDispositionGroupResponseChanged());
}

export function* fetchTCNDispositionGroupSaga() {
  yield takeLatest(
    tcnResponseTypes.TCN_DISPOSITION_GROUP_START,
    fetchTCNDispositionGroup,
  );
}

export function* resetTCNDispositionGroupSaga() {
  yield takeLatest(
    tcnResponseTypes.TCN_DISPOSITION_GROUP_RESPONSE_RESET_START,
    resetTCNDispositionGroupResponse,
  );
}

/** *********************** SATRT TCN RESPONSE EXPORT  LIST ************************ */

export function* tcnResponseListExport({ payload }: any) {
  const key: any = "CreateRequestReportKey";
  try {
    const jsonData: any = {
      BranchID: payload.BranchID,
      IsFresh: payload.IsFresh,
      ConditionExec: payload.ConditionExec,
      ExistRequestID: 1,
      CreateDateTime: payload.CreateDateTime,
      RequestReportPage: payload.RequestReportPage,
      CompanyID: payload.CompanyID,
      RequestedBy: payload.RequestedBy,
      URL: payload.URL,
      FromDate: payload.FromDate,
      ToDate: payload.ToDate,
      MemberID: payload.MemberID,
      DateType: payload.DateType,
      InstanceName: payload.InstanceName,
    };
    const fetchData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(ComonExportPage, fetchData);
    if (responseData.data.statusCode === "100") {
      yield put(tcnResponseExportAllFailure(responseData.data));
    } else {
      yield put(tcnResponseExportAllSuccess(responseData.data));
    }
  } catch (error) {
    yield put(tcnResponseExportAllFailure(error));
  }
}
export function* tcnResponseExportAllReset() {
  yield put(tcnResponseExportAllChanged());
}
export function* onExportListCallback() {
  yield takeLatest(
    tcnResponseTypes.TCN_RESPONSE_EXPORT_START,
    tcnResponseListExport,
  );
}
export function* onCallbackExportReset() {
  yield takeLatest(
    tcnResponseTypes.TCN_RESPONSE_EXPORT_RESET_START,
    tcnResponseExportAllReset,
  );
}
/************************* END TCN RESPONSE EXPORT ALL  LIST ************************ */

export function* tcnResponseSaga() {
  yield all([
    call(searchStartSaga),
    call(searchResetSaga),
    call(fetchTCNDispositionGroupSaga),
    call(resetTCNDispositionGroupSaga),
    call(onExportListCallback),
    call(onCallbackExportReset),
  ]);
}
